const Included = () => {
  return (
    <div className="container background_gradient-top">
      <div className="column w64 g1">
        <h2>What We Do Best</h2>
        <div className="columns g1">
          <div className="card column background_white shadow g1 p2">
            <strong className="purple">Balance Sheet Forecast</strong>
            <span className="ctext">
              Predict long-term financial health, solvency, and capital needs.
            </span>
            <i>$350 / report</i>
          </div>
          <div className="card column background_white shadow g1 p2">
            <strong className="purple">Profit and Loss Forecast</strong>
            <span className="ctext">
              Measure operational efficiency and profitability using accrual
              accounting.
            </span>
            <i>$350 / report</i>
          </div>
          <div className="card column background_white shadow g1 p2">
            <strong className="purple">Cash Flow Forecast</strong>
            <span className="ctext">
              Track the timing of cash movements to ensure short-term liquidity.
            </span>
            <i>$350 / report</i>
          </div>
          <div className="card column background_white shadow g1 p2">
            <strong className="purple">Custom Report</strong>
            <span className="ctext">
              Analyze your finances in the ways that work best for your
              business.
            </span>
            <i>$500 / report</i>
          </div>
        </div>
        <a
          className="cta"
          href="https://calendar.app.google/cgho9MaUp1oADCZLA"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get started
        </a>
      </div>
    </div>
  );
};

export default Included;
